export function asc(a: number, b: number) {
  return a - b;
}
